import React from "react";
import onepaylogo from "../../../assets/images/logo/payments/onepay.png";
import cardpaymentLogo from "../../../assets/images/logo/payments/visa-mastercard-small.png";

const KOKO_LOGO =
  "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/MAINLogo-HD_H_21.01.05.png";

const PaymentOptions = ({
  hasNonCodItem,
  kokoTaxRate,
  kokoTaxRateStatus,
  selectedPayment,
  selectedCardPayment,
  isCardPaymentsExpanded,
  onPaymentChange,
  onCardPaymentChange,
  onSelectCardPayments,
}) => (
  <div className="bm-pay-list">
    {hasNonCodItem ? (
      <div className="bm-note" style={{ marginTop: 0 }}>
        <i className="ph-fill ph-info" />
        <span>
          Cash on delivery isn't available because your order contains items
          that must be prepaid.
        </span>
      </div>
    ) : (
      <div className={`bm-pay ${selectedPayment === "payment3" ? "is-selected" : ""}`}>
        <label className="bm-pay__head" htmlFor="payment3">
          <input
            type="radio"
            name="payment"
            id="payment3"
            value="payment3"
            checked={selectedPayment === "payment3"}
            onChange={onPaymentChange}
          />
          <span className="bm-pay__label">
            <i className="ph-fill ph-money" />
            Cash on delivery
          </span>
        </label>
      </div>
    )}

    <div className={`bm-pay ${selectedPayment === "cardPayments" ? "is-selected" : ""}`}>
      <label className="bm-pay__head" htmlFor="cardPayments">
        <input
          type="radio"
          name="payment"
          id="cardPayments"
          value="cardPayments"
          checked={selectedPayment === "cardPayments"}
          onChange={onSelectCardPayments}
        />
        <span className="bm-pay__label">
          <img src={cardpaymentLogo} alt="Card payments" className="bm-pay__logo" />
        </span>
      </label>
      {selectedPayment === "cardPayments" && isCardPaymentsExpanded && (
        <div className="bm-pay__body">
          <label htmlFor="payment5">
            <input
              type="radio"
              name="cardPayment"
              id="payment5"
              value="payment5"
              checked={selectedCardPayment === "payment5"}
              onChange={onCardPaymentChange}
            />
            <img src={onepaylogo} alt="OnePay" className="bm-pay__logo" />
          </label>
        </div>
      )}
    </div>

    <div className={`bm-pay ${selectedPayment === "payment6" ? "is-selected" : ""}`}>
      <label className="bm-pay__head" htmlFor="payment6">
        <input
          type="radio"
          name="payment"
          id="payment6"
          value="payment6"
          checked={selectedPayment === "payment6"}
          onChange={onPaymentChange}
        />
        <span className="bm-pay__label">
          <img src={KOKO_LOGO} alt="KOKO Pay" className="bm-pay__logo" />
        </span>
      </label>
      {selectedPayment === "payment6" && (
        <div className="bm-pay__body">
          {kokoTaxRateStatus === "ready"
            ? `By selecting KOKO Pay, a ${kokoTaxRate}% tax will be added to your total. Please review the updated total before proceeding.`
            : kokoTaxRateStatus === "loading"
            ? "Loading the KOKO Pay tax rate..."
            : "Unable to load the KOKO Pay tax rate. Please refresh the page and try again."}
        </div>
      )}
    </div>
  </div>
);

export default PaymentOptions;
